import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "error" }
const _hoisted_14 = { class: "pull-right" }
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "error" }
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = ["disabled"]

import { ref, computed, watch, toRef } from 'vue'

    import type { EmailSnippetReadModel } from '@Alternatives/Alternatives/Domain/readmodels'
    import type { ValidationError } from '@common/types'
    import type { EmailSenderViewModel } from '@Alternatives/Alternatives/Components/EmailSender'

    import { EmailSenderFormSubmitEventPayload } from '@Alternatives/Alternatives/Components/EmailSender'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmailSender',
  props: {
    viewModel: {}
  },
  emits: ["form-submit"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived (from VM) ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const sending = computed({
        get: () => vm.value.sending,
        set: val => { vm.value.sending = val }
    })

    const alternativeName = computed(() => vm.value.alternativeName)
    const emailSnippets = computed(() => vm.value.emailSnippets)

    const subjectError = computed(() =>
        vm.value.errors.find(e => e.ErrorCode.startsWith('Subject.'))?.Error ?? null
    )

    const bodyHtmlError = computed(() =>
        vm.value.errors.find(e => e.ErrorCode.startsWith('Body.'))?.Error ?? null
    )

    const replyToEmailError = computed(() =>
        vm.value.errors.find(e => e.ErrorCode.startsWith('ReplyTo.'))?.Error ?? null
    )

    const toEmailsError = computed(() =>
        vm.value.errors.find(e => e.ErrorCode.startsWith('To.'))?.Error ?? null
    )

    // ---------------- local state ----------------

    const subject = ref('')
    const bodyHtml = ref('')
    const replyToEmail = ref('')
    const toEmails = ref('')

    // ---------------- methods ----------------

    function insertEmailSnippet(content: string)
    {
        bodyHtml.value = `${bodyHtml.value} ${content}`.trim()
    }

    function handleFormSubmit()
    {
        vm.value.clearEmailValidationErrors()

        sending.value = true

        const to = toEmails.value
            .split(/[,;]/)
            .map(e => e.trim())
            .filter(Boolean)

        emit(
            'form-submit',
            new EmailSenderFormSubmitEventPayload(
                vm.value.alternativeId!,
                subject.value,
                replyToEmail.value,
                to,
                bodyHtml.value
            )
        )
    }

    function close()
    {
        vm.value.close()
    }

    // ---------------- watchers ----------------

    watch(opened, val =>
    {
        if (!val)
            return

        vm.value.clearEmailValidationErrors()

        sending.value = false
        subject.value = ''
        bodyHtml.value = ''
        toEmails.value = vm.value.defaultTo ?? ''
        replyToEmail.value = vm.value.defaultReplyTo ?? ''
    })

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Send email: " + _toDisplayString(alternativeName.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "email-sender-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", null, "Send to:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toEmails).value = $event)),
                      type: "text",
                      class: "form-control",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        toEmails.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(toEmailsError.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "Subject:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subject).value = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        subject.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(subjectError.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "Reply to:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((replyToEmail).value = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        replyToEmail.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(replyToEmailError.value), 1 /* TEXT */)
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("a", {
                        class: "btn btn-outline-secondary dropdown-toggle",
                        "data-toggle": "dropdown"
                      }, " Insert ", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailSnippets.value, (s) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "dropdown-item",
                            key: s.Title,
                            onClick: ($event: any) => (insertEmailSnippet(s.Content))
                          }, _toDisplayString(s.Title), 9 /* TEXT, PROPS */, _hoisted_17))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bodyHtml).value = $event)),
                    class: "form-control",
                    rows: "5",
                    placeholder: "Type your message here...",
                    required: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      bodyHtml.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(bodyHtmlError.value), 1 /* TEXT */)
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "submit",
                  form: "email-sender-form",
                  disabled: sending.value,
                  class: "btn btn-primary"
                }, "Send", 8 /* PROPS */, _hoisted_20)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})